import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

// This is the time that the user has selected to change to
// Transient state
const slice = createSlice({
  name: '$changedTime',
  initialState,
  reducers: {
    setChangedTime(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, (state, action) => {
      return initialState;
    });
  },
});

export const { setChangedTime } = slice.actions;
export default slice.reducer;
